<template>

  <el-dialog v-model="centerDialogVisible" width="500" center>
    <template #footer>
      <div class="dialog-footer">

        <img style="height: 300px; width: 450;" v-if="imageType=='imageSensorUrl'"
          :src='axios.defaults.baseURL+"sensor/images/?type=Sensor&mac="+mac'>

        <img style="height: 300px; width: 450;" v-if="imageType=='imagePlaceUrl'"
          :src='axios.defaults.baseURL+"sensor/images/?type=Place&mac="+mac'>

      </div>
    </template>
  </el-dialog>

  <div class="sensor-place"
    :class="{ high: highWidget=='high', low: highWidget=='low', 'double-high': highWidget=='double-high', 'disconected':  date_update_param }">
    <div class="first-line-sensor-widget">
      <div style="display: flex">
        <el-tooltip effect="dark" :content="'Нет соединения с датчиком'" placement="top">
          <img v-show="date_update_param" class="info-warning" src=@/assets/imgs/warning.svg />
        </el-tooltip>

        <p style="white-space: nowrap;" class="middle-high" v-if="name"> {{ name }}</p>
        <p style="white-space: nowrap;" class="middle-high" v-if="!name">{{ mac }}</p>
      </div>
      <button v-if="sensor" @click="openWindowParam()">
        <img src="@/assets/imgs/pencil.svg" alt="">
      </button>
    </div>
    <div class="param-place">
      <div class="param-column">
        <div class="param-el" popup-text="Температура, °C">
          <div class="icon-param">
            <img src="@/assets/imgs/temperature.svg" alt="">
          </div>
          <p class="the-biggest">{{ tempShow }}</p>
          <p class="small-text name-param">Температура, °C</p>
        </div>

        <div class="param-el" :style="rpmStatusClass" popup-text="Вибрация, мм/с">
          <div class="icon-param">
            <img src="@/assets/imgs/vibration.svg" alt="">
          </div>
          <p class="the-biggest">{{ vibrationShow }}</p>
          <p class="small-text name-param">Вибрация, мм/с</p>
        </div>

        <div class="param-el" popup-text="Обороты, об/мин" v-if="addition_params.includes('rpm')">
          <div class="icon-param">
            <img src="@/assets/imgs/vibration.svg" alt="">
          </div>
          <p class="the-biggest">{{ rpm }}</p>
          <p class="small-text name-param">Обороты, об/мин</p>
        </div>
        <div class="param-el" popup-text="Мощность, Вт" v-if="addition_params.includes('power')">
          <div class="icon-param">
            <img src="@/assets/imgs/vibration.svg" alt="">
          </div>
          <p class="the-biggest">{{ power }}</p>
          <p class="small-text name-param">Мощность, Вт</p>
        </div>


        <div :style="{ border: isMotorLifeGone ? '2px solid #ff5252':'' }" class="param-el"
          popup-text="Время работы(всё), ч">
          <div class="icon-param">
            <img src="@/assets/imgs/time-on.svg" alt="">
          </div>
          <p class="the-biggest">{{ totalTimeShow }}</p>
          <p class="small-text name-param">Время работы(всё), ч</p>
        </div>

        <div v-if="isSensorImage">
          <div class="param-el" style="cursor: pointer;" popup-text="Фото датчика"
            @click="PhotoHendler('imageSensorUrl')">
            <div class="icon-param">
              <img style="height: 3.4vh; padding: 2px;" src="@/assets/imgs/image-icon.png" alt="">
            </div>
            <p style="text-align: center; margin: 11px 40px 0px 0px;">
              Фото Датчика
            </p>
          </div>
        </div>
      </div>
      <div class="param-column">
        <div class="param-el" popup-text="Время работы(месяц), ч">
          <div class="icon-param">
            <img src="@/assets/imgs/time-on.svg" alt="">
          </div>
          <p class="the-biggest">{{ monthTimeShow }}</p>
          <p class="small-text name-param">Время работы(месяц), ч</p>
        </div>
        <div class="param-el" popup-text="Время работы(неделя), ч">
          <div class="icon-param">
            <img src="@/assets/imgs/time-on.svg" alt="">
          </div>
          <p class="the-biggest">{{ weekTimeShow }}</p>
          <p class="small-text name-param">Время работы(неделя), ч</p>
        </div>
        <div class="param-el" popup-text="Время работы(день), ч">
          <div class="icon-param">
            <img src="@/assets/imgs/time-on.svg" alt="">
          </div>
          <p class="the-biggest">{{ dayTimeShow }}</p>
          <p class="small-text name-param">Время работы(день), ч</p>
        </div>
        <button v-if="sensor" class="white-status" @click="openGraphWindow()">
          <img src="@/assets/imgs/icon-chart.svg" alt="">
        </button>


        <div v-if="isPlaceImage">
          <div class="param-el" style="cursor: pointer;" popup-text="Место установки датчика"
            @click="PhotoHendler('imagePlaceUrl')">
            <div class="icon-param">
              <img style="height: 3.4vh; padding: 2px;" src="@/assets/imgs/image-icon.png" alt="">
            </div>
            <p>Место установки датчика</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import axios from '../../../config-axios'

export default {
  name: 'Compressor',
  props: ['name', 'temperature', 'vibration', 'total_time', 'month_time', 'week_time', 'day_time', 'power', 'rpm', 'id', 'mac', 'addition_params', 'message', 'isMotorLifeGone', 'sensor', 'levelVibrationsCode', 'date_update_param',
          'isSensorImage', 'isPlaceImage'],
  emits: ['open-graf', 'open-param'],
  data() {
    return {
      imageURL: '',
      localMessage: null,
      centerDialogVisible: false,
      imageType: '',
      noShowImages: {},
    }
  },
  methods: {

    showImage(type) {

      for (const msg of this.localMessage || []) {
        for (const item of msg?.[this.mac] || []) {
          if (item?.[type]) {
            return true;
          }
        }
      }
    },


    PhotoHendler(type) {
      this.centerDialogVisible = true
      this.imageType = type
    },

    openGraphWindow() {
      this.$emit('open-graf', this.id, this.name, 'sensor')
    },

    openWindowParam() {
      this.$emit('open-param', this.id, this.name, 'sensor')
    },
    getCurrentUnix() {
      return Math.floor(Date.now() / 1000)
    },
  },
  computed: {
    highWidget() {
      let numb = this.addition_params.length
      if (this.isSensorImage) {
        numb += 1;
      }
      if (numb == 3) {
        return 'double-high'
      }
      if (numb == 2 || this.isPlaceImage) {
        return 'high'
      }
      if (numb == 1) {
        return 'low'
      }
    },
    rpmStatusClass() {
      if (this.levelVibrationsCode == 1) {
        return 'border-color: #F97676;';
      } else if (this.levelVibrationsCode == 2) {
        return 'border-color: rgb(223 216 134);';
      }
    },

    effectiveMessage() {
      return this.localMessage !== null ? this.localMessage : this.message || [];
    },

    dayTimeShow() {
      if (this.day_time) {
        return (this.day_time / 60).toFixed(1);
      } else {
        return '-'
      }
    },
    weekTimeShow() {
      if (this.week_time) {
        return (this.week_time / 60).toFixed(1);
      } else {
        return '-'
      }
    },
    monthTimeShow() {
      if (this.month_time) {
        return (this.month_time / 60).toFixed(1);
      } else {
        return '-'
      }
    },
    tempShow() {
      if (this.temperature) {
        let answer = (this.temperature).toFixed(1);
        return answer != '0.0' ? answer : '-';
      }
      return '-';
    },
    vibrationShow() {
      if (this.vibration) {
        let answer = (this.vibration).toFixed(2);
        return answer != '0.00' ? answer : '-';
      }
      return '-';
    },
    totalTimeShow() {
      if (this.total_time) {
        return (this.total_time / 60).toFixed(1);
      } else {
        return '-'
      }
    },

    async currentImageURL() {
      if (!this.imageType) return null;

      for (const msg of this.localMessage || []) {
        for (const item of msg?.[this.mac] || []) {

          if (item?.[this.imageType]) {

            const data = {
              'imageSensorUrl': 'Sensor',
              'imagePlaceUrl': 'Place'
            }

            try {
              const response = await this.axios.get(`/sensor/images/?type=${data[this.imageType]}&mac=${this.mac}`, {
                responseType: 'blob'
              })

              //console.log(URL.createObjectURL(response.data))

              this.imageURL = URL.createObjectURL(response.data)

              return true

            } catch (error) {
              console.error(error)
            }

          }
        }
      }

      return null;
    },


  },
  watch: {
    message: {
      handler(newVal) {

        this.localMessage = this.message

        if (!newVal?.length) {

          const savedData = sessionStorage.getItem(`savedPhotoes`);
          if (savedData) {

            try {
              const parsedData = JSON.parse(savedData);

              // console.log(parsedData)

              this.localMessage = parsedData;

            } catch (e) {
              console.error('Ошибка парсинга данных из localStorage:', e);
            }
          }
        }



      },
      immediate: true,
      deep: true
    },

  },

  created() {
  },

  beforeUnmount() {
  }
}
</script>
<style noscoped lang="scss">
.sensor-place {
  // max-width: 573px;
  // min-width: 358px;
  height: 30.6vh;
  min-height: 97px;
  border-radius: 4px;
  background: var(--gray-color);

  &.disconected {
    background: #f1efd9;
  }
}

.info-warning {
  width: 25px;
  margin-left: 4%;
  margin-right: 4%;
}

.sensor-place.low {
  // max-width: 573px;
  // min-width: 358px;
  height: 30.6vh;
}

.sensor-place.high {
  // max-width: 573px;
  // min-width: 358px;
  height: 36.6vh;
}
.sensor-place.double-high {
  height: 42.6vh;
}

// .first-line-sensor-widget {
//   display: flex;
//   justify-content: space-between;
//   padding-right: 5%;
//   padding-top: 1%;

//   // button
// }

.first-line-sensor-widget {
  display: flex;
  justify-content: space-between;
  padding: 3px 5px;

  button {
    cursor: pointer;
    background: none;
    padding: 2px 3px;
    border-radius: 3px;
    transition: all .2s ease;

    &:hover {
      background: #f8f6f6;
    }

    &:active {
      background: var(--background-white, #FCFCFC);
    }
  }
}

.param-place {
  display: flex;
  justify-content: space-between;
  padding: 0 19px;
  // max-height: 27.2vh;
  // overflow-y: auto;
  // flex-grow: 1;

  .param-column {
    width: 47%;
  }

  .color-param-to {
    background: rgba(149, 149, 253, 0.39);
  }

  .param-el {
    // width: 9vw;
    width: 100%;
    min-width: 117px;
    height: 400px;
    min-height: 49px;
    border-radius: 5px;
    border: 2px solid var(--background-white, #FCFCFC);
    margin-bottom: 10px;
    position: relative;
    padding: 1px 11px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .icon-param {
      position: absolute;
      top: 4px;
      right: 4px;

      img {
        height: 4vh;
      }
    }

    &:after {
      position: absolute;
      z-index: 1;
      white-space: nowrap;
      // height: 100%;
      top: 102%;
      background: var(--background-white);
      font-size: 14px;
      padding: 2px 5px;
      box-shadow: 0px 20px 40px 9px rgba(0, 0, 0, 0.26);
      display: flex;
      border-radius: 3px;
      flex-direction: column;
      justify-items: center;
      align-self: center;
      content: attr(popup-text);
      color: black;
      opacity: 0;
      transition: opacity .2s ease;
    }

    &:hover::after {
      // &:after{
      opacity: 1;
    }
  }

  button {
    width: 100%;
    min-width: 117px;
    height: 5.5vh;
    min-height: 49px;
    border-radius: 5px;
    border: 2px solid var(--background-white, #FCFCFC);
    margin-bottom: 10px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all .2s ease;

    &:hover {
      background: #f8f6f6;
    }

    &:active {
      background: var(--gray-color, #EDEDED);
    }
  }

  .white-status {
    background: var(--background-white, #FCFCFCFF);
    cursor: pointer;
  }

  .green-status {
    background: var(--green-color, #B3DDBE);
  }

  .red-status {
    background: var(--red-color, #F97676);
  }
}

@media screen and (max-width: 1700px) {
  .name-param {
    display: none;
  }

  .green-status {
    .middle-high {
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-right: 300px;
    }
  }

  .red-status {
    .plain-text {
      font-family: Lato;
      font-size: 9px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .param-column {
    width: 33.3%;
  }

}

@media screen and (max-width: 1210px) {
  .name-param {
    display: contents;
  }

  .green-status {
    .middle-high {
      font-family: Lato;
      font-size: 22px;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0%;
      margin-right: 300px;
    }
  }

  .red-status {
    .plain-text {
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0%;
    }
  }
}

@media screen and (max-width: 1150px) {
  .name-param {
    display: none;
  }

  .green-status {
    .middle-high {
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-right: 300px;
    }
  }

  .red-status {
    .plain-text {
      font-family: Lato;
      font-size: 9px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .param-column {
    width: 33.3%;
  }
}

@media screen and (max-width: 810px) {
  .name-param {
    display: contents;
  }

  .green-status {
    .middle-high {
      font-family: Lato;
      font-size: 22px;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0%;
    }
  }

  .red-status {
    .plain-text {
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0%;
    }
  }
}

@media screen and (max-width: 610px) {
  .name-param {
    display: none;
  }

  .green-status {
    .middle-high {
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .red-status {
    .plain-text {
      font-family: Lato;
      font-size: 9px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .param-place {
    padding: 0 1px;
  }

  .param-column {
    width: 33.3%;
  }
}

@media screen and (max-height: 887px) {
  .param-place {
    .param-el {
      margin-bottom: 2px;
    }
  }

  .first-line {
    p {
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    img {
      height: 13px;
    }
  }

  .red-status {
    .plain-text {
      font-family: Lato;
      font-size: 9px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
}
</style>
